import React from 'react';

import * as S from './styles';

function Radioactive() {
  return <S.Giradioactive />;
}

export default Radioactive;